var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestroomsOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 65,
    viewBox: "0 0 75 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 14C64.8593 14 68 10.86 68 7C68 3.14065 64.86 0 61 0C57.1407 0 54 3.13996 54 7C54.0007 10.8593 57.1405 14 61 14V14Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14C16.8593 14 20 10.86 20 7C20 3.14065 16.86 0 13 0C9.14065 0 6 3.13996 6 7C6 10.8593 9.13996 14 13 14Z",
    fill: "#FF5910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9318 49.3647L70.4731 19.229C70.3684 18.5226 69.7683 18 69.0627 18H54.0796C53.3767 18 52.778 18.5186 52.6705 19.2217L48.017 49.5875C47.9527 50.0034 48.0727 50.4274 48.3439 50.7467C48.6138 51.0668 49.0103 51.2512 49.4261 51.2512H60.0653V63.5576C60.0653 64.3539 60.7039 65 61.4909 65C62.278 65 62.9166 64.3539 62.9166 63.5576L62.9172 51.2505H73.5558C73.5631 51.2512 73.5697 51.2512 73.5744 51.2505C74.3628 51.2505 75 50.6045 75 49.8082C75 49.6532 74.9761 49.5036 74.9317 49.3641L74.9318 49.3647Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5209 17H1.47968C1.04755 17 0.637426 17.1877 0.355975 17.5146C0.0752103 17.8414 -0.048649 18.2737 0.0174111 18.6992L4.84808 49.7096C4.95956 50.4283 5.58094 50.9572 6.31035 50.9572H12.52V63.5269C12.52 64.3402 13.182 65 13.9995 65C14.817 65 15.4789 64.3402 15.4789 63.5269V50.9572H21.8565C22.5893 50.9572 23.2114 50.4242 23.3201 49.7013L27.9836 18.691C28.0476 18.2668 27.9224 17.8366 27.6416 17.5111C27.3608 17.187 26.9514 17 26.5206 17L26.5209 17Z",
    fill: "#FF5910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0C36.6712 0 36 0.647833 36 1.44786V63.5521C36 64.3515 36.6712 65 37.5 65C38.3281 65 39 64.3515 39 63.5521V1.44786C39 0.648505 38.3281 0 37.5 0Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestroomsOrange);
export default __webpack_public_path__ + "static/media/restrooms_Orange.a9e11ed1e729f575605f5a2220ed8ae7.svg";
export { ForwardRef as ReactComponent };